<template>
    <div id="fb-post">
        <div class="headline ma-3 text-color bold">
            NẠP TIỀN
        </div>
        <div class="container-tabs">
            <v-tabs
                :background-color="COLOR.BG_MAIN_COLOR"
            >
                <v-tab href="#create-process" active-class="text-color">Nạp tiền</v-tab>
                <v-tab href="#activity-log"  active-class="text-color">Lịch sử biến động tài khoản</v-tab>
                <v-tab href="#activity-money"  active-class="text-color">Lịch sử nạp Tiền</v-tab>
                <v-tab href="#card-phone-log"  active-class="text-color">Lịch sử nạp thẻ</v-tab>
                <v-tab href="#report-error"  active-class="text-color">Báo lỗi nạp tiền</v-tab>
                <v-tab-item value="create-process">

                    <div class="container form-user-payment grid-list-md">

                        <!--videoRef-->
                        <div v-if="videoId">
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn nạp tiền</span>
                                </a>
                            </div>
                        </div>
                        
                        <v-row>
                            <v-col cols="12" >
                                <v-card class="pa-2 bg-white" outlined >
                                    <span class="mb-4 font-weight-bold">Chọn phương thức nạp tiền</span><br>
                                    <v-select
                                        solo
                                        :items="methods"
                                        v-model="method"
                                        item-text="name"
                                        item-value="value"
                                    ></v-select>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>

                    <UserPaymentSetting v-if="method == 1" />

                    <UserPaymentCard v-if="method == 2"/>

                    <!--video youtube-->
                    <v-layout align-center row class="pa-0" v-if="videoId" id="videoRef" style="background-color: #4267b2; padding: 12px !important; padding-top: 0px !important;">
                        <div class="container form-user-payment grid-list-md">
                            <v-flex md8>
                                <div class="col-sm-12 mb-n3" style="padding-right: 0px;
    padding-left: 0px;">
                                    <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                                </div>
                                <div class="col-sm-12 mb-n3" style="padding-right: 0px;
    padding-left: 0px;">
                                    <youtube :video-id="videoId" ref="youtube"
                                             @buffering="playing"
                                             @paused="paused"
                                             @ended="paused"
                                             @playing="playing"
                                             width="100%" height="650px">
                                    </youtube>
                                </div>
                            </v-flex>
                        </div>
                    </v-layout>

                </v-tab-item>
                <v-tab-item value="activity-log">
                    <UserPaymentActivityLog/>
                </v-tab-item>
                <v-tab-item value="activity-money">
                    <UserPaymentMoneyActivityLog/>
                </v-tab-item>
                <v-tab-item value="card-phone-log">
                    <UserPaymentCardPhoneLog/>
                </v-tab-item>
                <v-tab-item value="report-error">
                    <ReportError />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import UserPaymentSetting from "~/components/user-payment/UserPaymentSetting";
import UserPaymentCard from "~/components/user-payment/UserPaymentCard";
import UserPaymentActivityLog from "~/components/user-payment/UserPaymentActivityLog";
import UserPaymentMoneyActivityLog from "~/components/user-payment/UserPaymentMoneyActivityLog";
import UserPaymentCardPhoneLog from "~/components/user-payment/UserPaymentCardPhoneLog";
import ReportError from "~/components/user-payment/ReportError";
import { COLOR } from "~/config/constant";
import {
    CONFIG_OTHER_PAGE
} from "~/store/actions.type";
export default {
    components: {
        UserPaymentSetting,
        UserPaymentCard,
        UserPaymentActivityLog,
        UserPaymentCardPhoneLog,
        UserPaymentMoneyActivityLog,
        ReportError
    },
    data() {
        return {
            COLOR: COLOR,
            method: 1,
            methods: [
                {value: 1, name: 'Chuyển khoản ngân hàng'},
                {value: 2, name: 'Thẻ điện thoại'}
            ],

            videoId: '',
            videoStatus: true,
        }
    },
    methods: {
        async getDataFromApi () {
            this.data = await this.$store.dispatch(CONFIG_OTHER_PAGE);
            for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].type === 'user_payment') {
                    if (this.data[i].video) {
                        let videoId = this.youtube_parser(this.data[i].video);
                        if (videoId) {
                            this.videoId = videoId;
                        }
                    }
                }
            }
        },

        playing() {
            this.videoStatus = false;
        },
        paused() {
            this.videoStatus = true;
        },
        youtube_parser(url) {
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }
    },
    mounted() {
        this.getDataFromApi();
    },
};
</script>
<style lang="scss">
    @import "../../scss/main";
    #fb-post {
        .v-tabs-slider-wrapper {
            color: $mainColor !important;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
    }
</style>
